import { QueryObserverResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { createContext } from 'react';

import type { Person } from '@/types/person';
import RepositoryResponse from '@/types/repositoryResponse';

export interface PersonContextInterface {
  person: Person;
  refetch: () => Promise<
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    QueryObserverResult<RepositoryResponse<Person> | undefined, AxiosError<unknown, any>>
  >;
  updatePerson: () => Promise<void>;
}

const PersonContext = createContext({} as PersonContextInterface);

export default PersonContext;
